<span
  class="user-hover-card__trigger"
  cdkOverlayOrigin
  #triggerOrigin="cdkOverlayOrigin"
  (mouseenter)="openCard()"
  (mouseleave)="scheduleClose()"
  (focusin)="openCard()"
  (focusout)="scheduleClose()"
>
  <ng-content></ng-content>
</span>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOpen]="open()"
  [cdkConnectedOverlayOrigin]="triggerOrigin"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayViewportMargin]="12"
  [cdkConnectedOverlayFlexibleDimensions]="true"
  [cdkConnectedOverlayHasBackdrop]="false"
  (detach)="closeCard()"
  (overlayOutsideClick)="closeCard()"
>
  <div
    class="user-hover-card"
    [class.user-hover-card--composer-open]="canQuickMessage()"
    role="dialog"
    [attr.aria-label]="name()"
    (mouseenter)="cancelClose()"
    (mouseleave)="scheduleClose()"
  >
    <div class="user-hover-card__avatar" [style.--user-hover-accent]="accent()">
      @if (avatarUrl()) {
        <img [src]="avatarUrl()" [alt]="name() + ' profile photo'" />
      } @else {
        <span>{{ initials() }}</span>
      }
    </div>

    <div class="user-hover-card__details">
      <strong>{{ name() }}</strong>
      @if (email()) {
        <span>{{ email() }}</span>
      } @else {
        <span>No email available</span>
      }
    </div>

    @if (canQuickMessage()) {
      <div class="user-hover-card__composer">
        <textarea
          class="user-hover-card__composer-input"
          rows="2"
          placeholder="Send a quick message"
          [value]="draftMessage()"
          (input)="updateDraftMessage($event)"
          (keydown.enter)="$event.preventDefault(); sendQuickMessage()"
        ></textarea>
        <div class="user-hover-card__composer-actions">
          <button type="button" class="user-hover-card__text-action" (click)="draftMessage.set('')">Clear</button>
          <button type="button" class="user-hover-card__primary-action" [disabled]="!draftMessage().trim()" (click)="sendQuickMessage()">Send</button>
        </div>
      </div>
    }
  </div>
</ng-template>
